<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Motivos</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label for="Name">
                          <span class="required">*</span> Título:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="entity.title"
                          placeholder=""
                        />
                      </div>
                      <div class="col-md-4">
                        <label>Tipo</label>
                        <v-select
                          v-model="entity.type_id"
                          class="vselect"
                          :options="types"
                          :reduce="(types) => types.id"
                          :label="'title'"
                        />
                      </div>
                      <div class="col-md-12">
                        <label>Descrição:</label>
                        <textarea
                          v-model="entity.description"
                          class="form-control"
                          cols="30"
                          rows="10"
                        ></textarea>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Mapeamento (De/Para)</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-right mb-2">
                  <button
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#newMapping"
                  >
                    Adicionar
                  </button>
                </div>
                <div class="col-md-12">
                  <table class="table">
                    <tr>
                      <th scope="col" style="width: 45%">ID Externo</th>
                      <th scope="col" style="width: 45%">Nome Externo</th>
                      <th scope="col" style="width: 10%">Ações</th>
                    </tr>
                    <tr
                      v-for="(mapping, index) in entity.mappings"
                      :key="index"
                    >
                      <td style="width: 45%">{{ mapping.external_id }}</td>
                      <td style="width: 45%">{{ mapping.external_title }}</td>
                      <td style="width: 10%">
                        <button
                          class="btn btn-crud delete"
                          @click="removeMapping(index)"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="entity.mappings.length == 0">
                      <td colspan="3" align="center">Nenhum cadastrado</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="block text-right">
                    <router-link to="/reasons" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="newMapping"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newMappingTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Novo Mapeamento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label>ID Externo</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_mapping.external_id"
                />
              </div>
              <div class="col-md-6">
                <label>Nome Externo</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_mapping.external_title"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="addMapping">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      types: [],
      new_mapping: {
        external_id: null,
        external_title: null,
      },
      entity: {
        title: null,
        description: null,
        status: "1",
        mappings: [],
      },
    };
  },
  computed: {},
  methods: {
    removeMapping(index) {
      const self = this;

      if (!self.entity.id) {
        self.entity.mappings.splice(index, 1);
      } else {
        let api =
          self.$store.state.api +
          "reason-mappings/" +
          self.entity.mappings[index].id;

        axios
          .delete(api)
          .then((response) => {
            self.$message(
              "Sucesso",
              `Mapeamento removido com sucesso`,
              "success"
            );

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }
    },
    addMapping() {
      const self = this;

      if (!self.new_mapping.external_id || !self.new_mapping.external_title) {
        self.$message("Ops!", `Você precisa preencher todos os dados`, "error");
        return;
      }

      if (!self.entity.id) {
        self.entity.mappings.push(self.new_mapping);
      } else {
        let api = self.$store.state.api + "reason-mappings";

        self.new_mapping.reason_id = self.entity.id;

        axios
          .post(api, self.new_mapping)
          .then((response) => {
            self.$message(
              "Sucesso",
              `Mapeamento incluído com sucesso`,
              "success"
            );

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }

      self.new_mapping = {
        external_id: null,
        external_title: null,
      };

      $("#newMapping").modal("hide");
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "reasons";

      if (self.entity.id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.id;
      }

      axios
        .post(api, self.entity)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/reasons");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api = self.$store.state.api + "reasons/" + id + "?with[]=mappings";

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTypes: function () {
      const self = this;
      const api = self.$store.state.api + "types?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.types = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getEntity(id);
    }
    self.getTypes();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
